<template>
  <div class="container">
      <LoadingSpinner :loading="loading"> </LoadingSpinner>

      <div class="mt-4" style="max-width:545px">
        <h3>SAF-T Rapport</h3>

        <div v-if="!loading">
            <div v-if="hasMultiLocations()" class="mt-4">
              <span class="ingredient-title">Velg avdeling</span>
              <select class="form-select" v-model="locationId" @change="showTerminals()">
                <option v-for="(location, index) in locations" :key="index" :value="location.id">{{ location.name }}</option>
              </select>
            </div>

            <div v-if="terminals.length > 0">
                <SelectTerminal :terminals="terminals" :terminal="selectedTerminal" @setSelectedTerminal="setSelectedTerminal"/>

                <SelectDate ref="selectDateFrom" label="Velg fra og med dato"/>
                <SelectDate ref="selectDateTo" label="Velg til og med dato"/>

                <button type="button" class="bo_btn mt-3" :class="resultFetched ? 'mb-3' : 'mb-0'" @click="generateSaftReport"> Eksport av SAF-T kassasystem </button>

                <div v-if="resultFetched" class="xz-report">
                  <p class="no-report-found">SAF-T rapport har blitt sendt til din email.</p>
                </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
  import LoadingSpinner from "@/components/other/LoadingSpinner";
  import SelectDate from "@/components/other/SelectDate";
  import ReportService from "@/services/report/ReportService";
  import LocationUtil from "@/util/LocationUtil";
  import MerchantUtil from "@/util/MerchantUtil";
  import TerminalService from "@/services/terminal/TerminalService";
  import TerminalVisibility from "@/util/TerminalVisibility";
  import SelectTerminal from "@/components/report/SelectTerminal";

  export default {
    components: {LoadingSpinner, SelectTerminal, SelectDate},
    data() {
      return {
        loading: true,

        locationId: '',
        locations: [],
        merchant: '',
        company: {},
        terminals: [],
        selectedTerminal: {},
        vat: {},
        fromDate: new Date(),
        toDate: new Date(),
        resultFetched: false
      };
    },
    mounted() {
      ReportService.getDataForReportGui().then(
          (response) => {
            let dataForGui = response.data;
            //console.log("dataForGui: " +  JSON.stringify(dataForGui));
            this.merchant = dataForGui.merchant;
            this.company = dataForGui.company;
            this.locations = dataForGui.locations;
            this.vat = dataForGui.vat;

            this.locationId = this.locations.length ? this.locations[0].id : '';

            this.showTerminals();
          },
          (error) => {
            console.log(error);
          }
      );
    },
    methods: {
      hasMultiLocations(){
        return LocationUtil.hasMultiLocations();
      },
      showTerminals() {
        this.loading = true;
        this.resultFetched = false;

        TerminalService.getTerminalsForLocation(this.locationId).then(
            (response) => {
              let filteredTerminals = [];

              // A terminal SUPER_ADMIN hid from the merchant (a test till) is left out for everyone else — SUPER_ADMIN
              // still sees it here, so its export can be produced if it is ever asked for.
              let availableTerminals = TerminalVisibility.forMerchantView(response.data);
              for(let i = 0; i < availableTerminals.length; i++) {
                let terminal = availableTerminals[i];
                if(terminal.terminalType !== 'KDS'){ //SAF-T report only for POS and KIOSK terminal
                  filteredTerminals.push(terminal);
                }
              }

              this.terminals = filteredTerminals;
              this.selectedTerminal = this.terminals.length > 0 ? this.terminals[0] : {};

              this.loading = false;
            },
            (error) => {
              console.log(error);
            }
        );
      },
      setSelectedTerminal(terminal){
        this.selectedTerminal = terminal;
        this.resultFetched = false;
      },
      useFunctionality(){
        return MerchantUtil.useFunctionality();
      },
      getLocation(){
        return LocationUtil.getLocation(this.locationId);
      },
      generateSaftReport() {
        this.loading = true;
        let fromDate =  this.$refs.selectDateFrom.getSelectedDate();
        let toDate =  this.$refs.selectDateTo.getSelectedDate();
        this.fromDate = fromDate;
        this.toDate = toDate;

        ReportService.generateSaftReport(this.locationId, this.selectedTerminal.id, fromDate, toDate).then(
            (response) => {
              if(response.data){
                //console.log(response.data.result);
              }

              this.loading = false;
              this.resultFetched = true;
            },
            (error) => {
              console.log(error);
            }
        );
      }
    }
  };
</script>
